import { ViewModel, View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { BankManipulationView } from "./bankManipulation-view"

export class BankManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("bankManipulation-viewModel.managementOfBanks", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.banks = ObservableArray.create<bank>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new BankManipulationView();
    }
    public getTypeId(): string {
        return "VM-594DD169-A03F-4B98-A207-21F191E966D3"
    }
    public set banks(v: ObservableArray<bank>) { this._banks = v; } public get banks(): ObservableArray<bank> { return this._banks; } private _banks: ObservableArray<bank>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;

    refresh() {
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/GetAllBank', {
                FilteringInformation: filteringInformation
            });
            let rowNumber = 1;
            this.banks.update(...result.Bank.map(q => {
                let r = new bank(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.name = q.Name;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async requestBankCreation() {
        let editor = new bankEditor(this, new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if (resultCode == 'done') {
            this.loader.refresh();
        }
    }

    async bankUpdater(bank: bank) {
        let editor = new bankEditor(this, new UpdateServerUpdater());
        bank.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if (resultCode == 'done') {
            this.loader.refresh();
        }
    }
}

export class bank extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: BankManipulationViewModel) {
        super(parent);
        this._typedParent = parent;

    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;

    private _typedParent: BankManipulationViewModel;


    cloneTo(bank: bank) {
        bank.id = this.id;
        bank.name = this.name;
    }

    async edit() {
        this._typedParent.bankUpdater(this);
    }
}

interface IServerUpdater {
    execute(bank: bank): Promise<void>;
    getSuccessMessage(): string;
}

class InsertServerUpdater implements IServerUpdater {
    getSuccessMessage(): string {
        return translate("bankManipulation-viewModel.successfullyRegistered", {});
    }
    async execute(bank: bank): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/CreateBank', {
            Name: bank.name,
        });
        if (result.IsSuccessful == false) {
            throw "new Error";
        }
    }
}
class UpdateServerUpdater implements IServerUpdater {
    getSuccessMessage(): string {
        return translate("bankManipulation-viewModel.successfullyUpdated", {});

    }
    async execute(bank: bank): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/UpdateBank', {
            Id: bank.id,
            Name: bank.name,
        });
        if (result.IsSuccessful == false) {
            throw "new Error";
        }
    }
}

export class bankEditor extends bank implements IPopup {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }

    constructor(parent: BankManipulationViewModel, serverUpdater: IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;

    }
    closePopup(resultCode: string = null) {
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push(translate("bankManipulation-viewModel.bankNameError", {}));
        }
        return result;
    }

    async save() {
        try {
            let verificationResult = this.verify();
            if (verificationResult.length > 0) {
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage, translate("bankManipulation-viewModel.bankErorr", {}));
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(), translate("bankManipulation-viewModel.successfulOperation", {}));
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(translate("bankManipulation-viewModel.operationErorr", {}), translate("bankManipulation-viewModel.error", {}));
        } finally {
            this.isLoading = false;
        }
    }

    back() {
        this.closePopup();
    }
}

